export const hourlyCalendar = {
  title: "Calendário por horas",
  navSubtitle: "Venda por horas do seu hotel",
  hotel: "Hotel",
  rooms: "Quartos",
  roomsAbbr: "qtos",
  noDisp: "Indisp.",
  footer: {
    free: "{n} livres",
    occupied: "{n} ocupados",
    cleaning: "{n} em limpeza",
    timezone: "Fuso horário: {tz}",
  },
  today: "Hoje",
  prevDay: "Dia anterior",
  nextDay: "Dia seguinte",
  newStay: "Nova estadia",
  settingsBtn: "Definições da venda por horas",
  retry: "Tentar de novo",
  dragHint: "Arraste sobre um quarto para criar uma estadia",
  groupFree: "{free} de {total} livres",
  zoom: { label: "Zoom", compact: "Compacta", normal: "Normal", wide: "Ampla" },
  duration: { min: "{n} min", h: "{n} h", hmin: "{h} h {m} min" },
  kpi: {
    free: "Livres agora",
    occupied: "Ocupados",
    cleaning: "Em limpeza",
    arrivals: "Chegam em 1 h",
    overdueAlert: "1 quarto passou da hora | {n} quartos passaram da hora",
  },
  state: {
    free: "Livre",
    freeNext: "Livre · próxima {time}",
    soon: "Chega às {time}",
    occupied: "Ocupado",
    occupiedLeft: "Ocupado · faltam {time}",
    overdue: "Passou {time}",
    due: "À espera da entrada",
    cleaning: "Limpeza · {time}",
    closed: "Fechado",
    maintenance: "Fora de serviço",
  },
  status: {
    booked: "Reservada",
    in_house: "Em curso",
    checked_out: "Terminada",
    cancelled: "Cancelada",
    no_show: "Não compareceu",
  },
  block: {
    noName: "Sem nome",
    blocked: "Bloqueado",
    night: "Noite",
    closed: "Fechado",
    maintenance: "Fora de serviço",
    left: "Faltam {time}",
  },
  legend: {
    booked: "Reservada",
    inHouse: "Em curso",
    overdue: "Passou da hora",
    cleaning: "Limpeza",
    night: "Reserva por noite",
    closed: "Fechado",
  },
  rangeMenu: {
    create: "Criar estadia",
    createSub: "No horário selecionado",
    block: "Bloquear este horário",
    blockSub: "O quarto não se vende nesse intervalo",
    closeDay: "Fechar o quarto o dia todo",
    closeDaySub: "Nesse dia este quarto não se vende",
  },
  blockMenu: {
    editReason: "Mudar o motivo",
    editReasonSub: "Aparece no calendário",
    remove: "Retirar o bloqueio",
    removeSub: "O quarto volta a vender-se",
  },
  blockModal: {
    titleRange: "Bloquear este horário",
    titleDay: "Fechar o quarto",
    titleEdit: "Motivo do bloqueio",
    msgRange: "{room} não será vendido das {range}.",
    msgDay: "{room} não será vendido em {date}.",
    msgDayRest: "{room} não se venderá o resto do dia (a partir das {time}).",
    msgEdit: "{room}",
    reasonLabel: "Motivo",
    reasonHint: "(aparece no calendário)",
    placeholder: "Manutenção, uso próprio…",
    cancel: "Cancelar",
    block: "Bloquear",
    save: "Guardar",
    presetMaintenance: "Manutenção",
    presetOwner: "Uso do proprietário",
    presetRepair: "Obras",
    presetDeepClean: "Limpeza profunda",
    presetClosed: "Fechado",
  },
  drawer: {
    close: "Fechar",
    closeBtn: "Fechar",
    newTitle: "Nova estadia",
    newPill: "Nova",
    when: "Quando",
    room: "Quarto",
    start: "Entrada",
    end: "Saída",
    nextDay: "dia seguinte",
    duration: "Duração",
    other: "Outra",
    free: "Quarto livre nesse horário",
    freeWithCleaning: "Livre · guardam-se {n} min para limpar à saída",
    freeWillClose: "Livre · depois fica fechado até às {hour}",
    busy: "Ocupado das {from} às {to}",
    busyClosed: "Fechado das {from} às {to}",
    busyMaintenance: "Quarto fora de serviço",
    guest: "Cliente",
    guestName: "Nome",
    phone: "Telefone",
    optional: "Opcional",
    guests: "Pessoas",
    charge: "Cobrança",
    price: "Preço",
    method: "Forma de pagamento",
    methods: { cash: "Dinheiro", card: "Cartão", transfer: "Transferência", other: "Outro" },
    paid: "Cobrado",
    paidHint: "Já tem o dinheiro desta estadia.",
    notes: "Notas",
    notesPh: "Matrícula, pedidos, o que for preciso",
    guestTitle: "Registo do hóspede",
    sendCheckin: "Enviar link de check-in",
    sendCheckinHint: "Envia-se ao guardar, para o telefone do hóspede.",
    sendCheckinNoPhone: "Escreve o telefone do hóspede para lhe poderes mandar o check-in.",
    doCheckin: "Fazer check-in",
    edit: "Editar",
    client: "Cliente",
    paidYes: "Cobrado",
    paidNo: "Por cobrar",
    markPaid: "Marcar como cobrado",
    doCheckinHint: "Abre-o no telemóvel do hóspede ou passa-lhe o link: nome, apelidos e documento, com scanner se quiser.",
    copyLink: "Copiar link",
    copied: "Link copiado",
    checkinDone: "Check-in feito · {n} hóspede registado | Check-in feito · {n} hóspedes registados",
    checkinErrors: {
      no_reservation: "Liga «Registar as estadias como reservas» nas definições para poderes pedir o check-in.",
      no_phone: "Escreve o telefone do hóspede para lho poderes mandar.",
      send_failed: "Não foi possível enviar. Tenta copiar o link e passá-lo tu.",
      not_requested: "Não foi possível enviar. Tenta copiar o link e passá-lo tu.",
    },
    checkinSent: "Check-in enviado",
    sendCheckinFailed: "Não foi possível enviar o check-in. Verifica o telefone do hóspede.",
    save: "Guardar",
    saveAndIn: "Guardar e registar entrada",
    saveChanges: "Guardar alterações",
    checkIn: "Registar entrada",
    checkOut: "Registar saída",
    extend30: "30 min",
    extend60: "1 h",
    extendOther: "Outro",
    extendHow: "Prolongar",
    extendApply: "Prolongar",
    cancelBtn: "Cancelar",
    checkOutNotYet: "A saída poderá ser registada quando a estadia começar",
    confirmEarlyOutTitle: "A estadia ainda não começou",
    confirmEarlyOut: "Esta estadia começa mais tarde. Registar a saída agora fecha-a e liberta o quarto. Se o cliente não veio, use «Não compareceu».",
    noShow: "Não compareceu",
    cancelStay: "Cancelar estadia",
    keep: "Voltar",
    confirmCancel: "Anula-se e o quarto fica livre nesse horário. Não se pode desfazer.",
    confirmNoShow: "A faixa volta a ficar livre para vender. Fica registado que o cliente não veio.",
    confirmNoShowInHouse: "Estava dentro, mas não chegou a subir: desfaz-se a entrada e a faixa volta a ficar livre.",
    confirmCancelInHouse: "Estava dentro: desfaz-se a entrada, anula-se a estadia e o quarto fica livre. Não se pode desfazer.",
    confirmNoShowTitle: "Não apareceu?",
    confirmCancelTitle: "Cancelar a estadia?",
    remaining: "Faltam {time}",
    overdue: "Passou {time} da hora",
    startsIn: "Começa em {time}",
    waiting: "A hora já começou: à espera da entrada",
    closedInfo: "Estadia fechada: só se podem alterar a cobrança e as notas.",
    night: {
      title: "Reserva por noites",
      dates: "De {from} a {to}",
      code: "Código",
      channel: "Canal",
      hint: "As reservas por noites gerem-se no calendário de hotel. Aparecem aqui para que nenhuma estadia por horas se cruze com elas.",
      open: "Ir para o calendário de hotel",
    },
  },
  settings: {
    title: "Venda por horas",
    enable: "Vender por horas",
    subtitle: "Como este hotel vende por horas",
    offTitle: "Se a desativar",
    offBody: "O calendário por horas deixa de estar disponível e o hotel volta a funcionar como antes. Nada é apagado.",
    offBodyStays: "Tem {n} estadias por horas futuras: não são apagadas, mas deixará de as ver até voltar a ativá-la.",
    enabledOn: "Ativada: o calendário por horas está em uso",
    enabledOff: "Desativada",
    requirements: "Requisitos",
    req: {
      rooms: "Quartos criados ({n})",
      channels: "Sem canais de venda ligados",
      ical: "Sem calendários iCal sincronizados",
      web: "Reserva pela web desativada",
      nights: "{n} reservas por noites futuras: aparecem no calendário e bloqueiam os seus quartos",
    },
    reqWhy: "Os canais, o iCal e a web vendem noites e não sabem nada de horas: com qualquer um deles ligado, o mesmo quarto podia ser vendido duas vezes.",
    cleaning: "Limpeza entre estadias",
    cleaningHint: "Reserva-se automaticamente depois de cada saída.",
    pending: "Pendente de limpeza",
    pendingHint: "Quando um cliente sai, o quarto fica marcado «por limpar» em Limpeza e na app durante este tempo. NÃO bloqueia a venda: se entrar alguém antes, limpa-se nessa altura.",
    none: "nenhuma",
    minutes: "min",
    hours: "h",
    closeTitle: "Fechar até à hora de abertura",
    closeHint: "Para quando não se limpa logo: o quarto fica fechado e ninguém o pode vender até abrir.",
    closeAfterStay: "Ao terminar uma estadia, deixar o quarto fechado",
    closeAfterStayHint: "Fecha sozinho até à hora de abertura do dia seguinte. Se o limpar antes, carregue em «Já está limpo» e volta a vender-se.",
    afterTitle: "Depois de cada estadia",
    afterHint: "Quanto tempo o quarto deixa de ser vendido quando sai um cliente.",
    untilOpening: "Até à abertura",
    reopenHour: "Hora de abertura da venda",
    reopenNote: "Os quartos sujos voltam a vender-se às {hour}.",
    markClean: "Já está limpo",
    markCleanHint: "Abre o quarto agora, sem esperar pela hora de abertura.",
    closeThisStay: "Deixar o quarto fechado ao terminar",
    closeThisStayHint: "Não se poderá vender até às {hour}. A hora, nas definições.",
    dayStart: "Início do dia do calendário",
    dayRange: "das {from} às {from} do dia seguinte",
    dayStartHint: "Escolha a hora de menos movimento: assim a noite vê-se inteira, sem cortes.",
    quickHours: "Durações rápidas",
    quickHoursHint: "Aparecem como atalhos ao criar uma estadia (até 6).",
    guestTitle: "Registo do hóspede",
    asReservation: "Registar as estadias como reservas",
    asReservationHint: "Cada estadia cria a sua reserva: é assim que o dinheiro aparece nos relatórios e que pode pedir o check-in e o registo de hóspedes. Se desligar, as vendas por hora não entram na sua receita.",
    checkinDefault: "Pedir o check-in por omissão",
    checkinDefaultHint: "O interruptor da ficha da estadia virá ligado.",
    guestHint: "Estas reservas não recebem os avisos pensados para noites (boas-vindas, chegada, saída nem avaliação): o link de check-in envia-se quando tu o pedes.",
    save: "Guardar definições",
    saved: "Definições guardadas",
  },
  empty: {
    eyebrow: "Venda por horas",
    title: "Venda os seus quartos por horas",
    body: "Um calendário pensado para motéis e hotéis de estadias curtas: vê cada quarto ao minuto, cria estadias arrastando e a limpeza entre uma e outra reserva-se sozinha.",
    point1: "Estado de cada quarto em tempo real",
    point2: "Arraste para criar, mover ou prolongar estadias",
    point3: "Limpeza entre estadias, automática",
    cta: "Ativar venda por horas",
    ctaBlocked: "Cumpra os requisitos para a ativar",
    noHotelsTitle: "Ainda não tem um hotel",
    noHotels: "A venda por horas funciona com alojamentos do tipo hotel que tenham quartos criados.",
  },
  guide: {
    open: "Manual de uso",
    title: "Como funciona o calendário por horas",
    subtitle: "O essencial num minuto: criar estadias, registar entradas e saídas e fechar quartos que não vais vender.",
    createTitle: "Criar uma estadia",
    createBody: "Arrasta sobre a linha do quarto, da hora de entrada até à de saída. Também podes carregar em «Nova estadia» e escrever as horas à mão.",
    moveTitle: "Mover e prolongar",
    moveBody: "Arrasta a barra para mudar de hora ou de quarto. Puxando a borda direita alongas ou encurtas a estadia. Se o espaço estiver ocupado, o calendário não te deixa largá-la.",
    checkinTitle: "Entrada e saída",
    checkinBody: "Abre a estadia e regista a entrada quando o hóspede chegar e a saída quando sair. Se passar da hora, a barra fica vermelha com os minutos a mais.",
    cleaningTitle: "Limpeza entre estadias",
    cleaningBody: "Depois de cada saída reserva-se sozinha a faixa de limpeza que configuraste. Ninguém pode entrar nesse intervalo.",
    blockTitle: "Bloquear um horário ou fechar o quarto",
    blockBody: "Seleciona um intervalo e escolhe «Bloquear este horário», ou «Fechar o quarto todo o dia» se nesse dia não o vais vender. Carrega no bloqueio para mudar o motivo ou retirá-lo.",
    settingsTitle: "Definições",
    settingsBody: "Na engrenagem configuras o tempo de limpeza, a hora a que começa o dia do calendário e as durações rápidas que vês ao criar uma estadia.",
    colorsTitle: "O que significa cada cor",
    colors: {
      booked: "Criada, o hóspede ainda não entrou",
      inHouse: "O hóspede está no quarto",
      overdue: "Passou da hora de saída",
      cleaning: "Faixa reservada para limpar",
      night: "Vem do calendário por noites",
      closed: "Bloqueada ou fechada à mão",
    },
    otasTitle: "Reservas por noites e canais",
    otasBody: "As reservas por noites aparecem aqui para saberes que quartos estão ocupados, mas geres-as no calendário do hotel. Enquanto venderes por horas, este alojamento não se liga às OTAs.",
    gotIt: "Entendido",
  },
  toasts: {
    created: "Estadia criada",
    checkedIn: "Entrada registada",
    checkedOut: "Saída registada · limpeza em curso",
    updated: "Alterações guardadas",
    extended: "Estadia prolongada",
    cancelled: "Estadia cancelada",
    noShow: "Marcada como não compareceu",
    moved: "Estadia movida",
    resized: "Duração atualizada",
    activated: "Venda por horas ativada",
    blocked: "Horário bloqueado",
    blockUpdated: "Motivo atualizado",
    blockRemoved: "Bloqueio retirado",
    loadError: "Não foi possível carregar o calendário por horas",
    error: "Não foi possível guardar. Tente de novo.",
  },
  errors: {
    room_busy: "O quarto está ocupado das {from} às {to}",
    hourly_disabled: "A venda por horas não está ativada neste hotel.",
    room_maintenance: "Esse quarto está fora de serviço.",
    room_not_found: "Esse quarto não pertence a este hotel.",
    invalid_duration: "A duração tem de estar entre 30 minutos e 48 horas.",
    invalid_start: "A hora de entrada não é válida.",
    stay_closed: "Esta estadia já está fechada: não se pode mover.",
    invalid_status: "Essa ação não é possível no estado atual da estadia.",
    requirements_not_met: "Este hotel ainda não cumpre os requisitos para vender por horas.",
    not_found: "Não encontrámos o que procura. Recarregue a página.",
    generic: "Algo correu mal. Tente de novo.",
  },
};
